import SVG from "../../../Components/SVG";
import Overview from "../../../Components/Cards/Information/Overview";
import MobileCarousel from "../../../Components/Cards/Information/MobileCarousel";

export default function MainStats({ accountData, accLoading }) {
  const shouldShowTradingDays =
    accountData !== null &&
    accountData !== undefined &&
    Object.prototype.hasOwnProperty.call(accountData, "trading_days");
  const shouldShowCompletedWithdraws =
    accountData !== null &&
    accountData !== undefined &&
    !shouldShowTradingDays &&
    Object.prototype.hasOwnProperty.call(
      accountData,
      "completed_withdraws_sum",
    );

  return (
    <div className="flex flex-col p-3 gap-3 items-center rounded-2xl overflow-hidden bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <h3 className="flex gap-2.5 items-center mb-1.5 w-full justify-start sm:justify-center">
        <SVG
          name="stats"
          classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5"
        />
        <span className="text-base font-medium text-zi-text-light/50 dark:text-zi-text-dark/50">
          آمار کلی
        </span>
      </h3>
      <MobileCarousel
        alignStart
        itemLabel="کارت آمار"
        className="!gap-3 sm:flex-col"
      >
        <Overview
          color="blue"
          width="250px"
          className=""
          title="بالانس"
          accLoading={accLoading}
          value={
            accountData !== null && accountData !== undefined
              ? `$${Number(
                  Number(accountData.current_balance).toFixed(2),
                ).toLocaleString()}`
              : ""
          }
          data=""
          svgName="balance"
          svgClassName=""
        />
        <Overview
          color="blue"
          width="250px"
          className=""
          title="اکوییتی"
          accLoading={accLoading}
          value={
            accountData !== null && accountData !== undefined
              ? `$${Number(
                  Number(accountData.equity).toFixed(2),
                ).toLocaleString()}`
              : ""
          }
          data=""
          svgName="balance"
          svgClassName=""
        />
        <Overview
          color=""
          width="250px"
          className=""
          accLoading={accLoading}
          title="سود / زیان قطعی"
          pnl={true}
          value={
            accountData !== null && accountData !== undefined
              ? Number(accountData.realized_pl) >= 0
                ? `$${Number(
                    Number(accountData.realized_pl).toFixed(2),
                  ).toLocaleString()}`
                : `-$${Number(
                    Number(-1 * accountData.realized_pl).toFixed(2),
                  ).toLocaleString()}`
              : ""
          }
          data=""
          svgName={
            accountData !== null && accountData !== undefined
              ? accountData.realized_pl >= 0
                ? "pnl"
                : "pnlloss"
              : "pnl"
          }
          svgClassName=""
        />
        <Overview
          color=""
          width="250px"
          className=""
          title="سود / زیان غیر قطعی"
          pnl={true}
          accLoading={accLoading}
          value={
            accountData !== null && accountData !== undefined
              ? Number(accountData.unrealized_pl) >= 0
                ? `$${Number(
                    Number(accountData.unrealized_pl).toFixed(2),
                  ).toLocaleString()}`
                : `-$${Number(
                    Number(-1 * accountData.unrealized_pl).toFixed(2),
                  ).toLocaleString()}`
              : ""
          }
          data=""
          svgName={
            accountData !== null && accountData !== undefined
              ? accountData.unrealized_pl >= 0
                ? "pnl"
                : "pnlloss"
              : "pnl"
          }
          svgClassName=""
        />
        {shouldShowTradingDays && (
          <Overview
            color="yellow"
            width="250px"
            className=""
            title="روزهای معاملاتی"
            days={true}
            accLoading={accLoading}
            value={`${accountData.trading_days}`}
            data=""
            svgName="days"
            svgClassName=""
          />
        )}
        {shouldShowCompletedWithdraws && (
          <Overview
            color="yellow"
            width="250px"
            className=""
            title="مجموع برداشت‌های موفق"
            accLoading={accLoading}
            value={`$${Number(
              Number(accountData.completed_withdraws_sum).toFixed(2),
            ).toLocaleString()}`}
            data=""
            svgName="withdraw"
            svgClassName="stroke-zi-text-dark"
          />
        )}
      </MobileCarousel>
    </div>
  );
}
